/**
 * @fileoverview GlobalStateProvider is used to inject global state into the app. This is used to allow mocking in storybook
 */
import React from "react";

import { defaultGlobalState, GlobalStateContext } from "@lib/globalState";

import type { GlobalStateProviderProps } from "./types";

export const GlobalStateProvider = ({
  currentAppGroupId,
  children,
}: GlobalStateProviderProps): React.ReactElement => {
  const value = React.useMemo(
    () => ({ ...defaultGlobalState, currentAppGroupId: currentAppGroupId || defaultGlobalState.currentAppGroupId }),
    [currentAppGroupId]
  );
  return <GlobalStateContext.Provider value={value}>{children}</GlobalStateContext.Provider>;
};
